import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import { injectIntl, FormattedMessage } from 'react-intl';
import { useFlags } from 'launchdarkly-react-client-sdk';
import enums from '../../constants/defaultEnums';
import formUtils from '../../utils/formUtils';
import {
  CustomSelectField,
  CustomInputField,
  CustomDateField,
  CustomLocationAddressField,
  CustomCheckboxField
} from '../../components';

function NetworkConsent() {
  const language = 'en';


  return (
    true ? (
      <div>
        <h3 className='personal ui-h3-heavy'>
          <FormattedMessage
 id="7FU+y1" description="networkConsent"
            defaultMessage="Referral Network Consent"
          />
        </h3>
        <small className='mb-5'>
          <i>        
            <FormattedMessage
 id="nHxCdm" description="networkConsent2"
              defaultMessage="Powered by Unite US"
            />
          </i>
        </small>
        <div className='mt-5'>
          <CustomCheckboxField
            name="first_name"
            label={
              <>
                <FormattedMessage
                  id="nupZUv"
                  description="networkConsentWithoutLink"
                  defaultMessage="I consent to sharing my information with a network of health and social service providers to connect me with services. For more information about how your information may be used, please "
                />{' '}
                <a href="https://uniteus.com/privacy-policy/" target="_blank" rel="noopener noreferrer" className="font-bold">
                    <FormattedMessage
                      id="70H6EA"                      
                      description="clickHereLink"
                      defaultMessage="click here"
                    />
                </a>                    
                .
              </>
            }
            id="uu_network_consent_check"
            required
            language={language}
          />
        </div>
      </div>
    ) : ''
  );
}

// ScreenConsent.propTypes = {
//   languagesOptions: PropTypes.arrayOf(
//     PropTypes.shape({
//       value: PropTypes.string.isRequired,
//       display_name: PropTypes.string.isRequired,
//     })
//   ),
// };

// ScreenConsent.defaultProps = {
//   languagesOptions: [],
// };
export default injectIntl(NetworkConsent);
